import React from 'react'
import ResizeObserver from 'resize-observer-polyfill'
import { assignIn, throttle } from 'lodash'

const isValidRef = (ref) => {
  const refKeys = ref ? Object.keys(ref) : []
  return ref && typeof ref === 'object' && refKeys.includes('current')
}

const onResize = (ref, throttleVal, setContentRect) => {
  return throttle((entries) => {
    const entry = entries[0]

    const { x, y, width, height, top, right, bottom, left } = ref.current.getBoundingClientRect()

    const boundingDims = {
      screenX: x || 0,
      screenY: y || 0,
      borderBoxWidth: width || 0,
      borderBoxHeight: height || 0,
      screenTop: top || 0,
      screenRight: right || 0,
      screenBottom: bottom || 0,
      screenLeft: left || 0,
    }

    const merged = assignIn({}, entry.contentRect, boundingDims)

    setContentRect(merged)
  }, throttleVal)
}

export const useDimensions = (ref, throttleVal = 80) => {
  const [contentRect, setContentRect] = React.useState({})

  if (!isValidRef(ref)) {
    throw new Error('You must pass a valid ref to the useDimensions hook')
  }

  React.useEffect(() => {
    if (!ref.current) {
      return
    }

    const refCurrent = ref.current
    const resizeObeserver = new ResizeObserver(onResize(ref, throttleVal, setContentRect))
    resizeObeserver.observe(refCurrent)

    return () => resizeObeserver.unobserve(refCurrent)
  }, [ref, throttleVal])

  return contentRect
}
